import Ajax from '@/plugins/ajax'
/**
 * 取后端配置
 * @param {*} code 
 * @returns 
 */
const getConfigValue = function (code) {
    return Ajax({
        url: '/api/commons/configs/getConfigByCode',
        params: {
            code
        }
    }).then(function (res) {
        return res.data
    })
}
/**
 * 取后端配置
 * @param {*} code 
 * @returns
 */
const isConfigured = function (code) {
    return getConfigValue(code).then(function (config) {
        return config && config.data == '1'
    })
}

export default {
    getConfigValue,
    isConfigured
}